module.exports = __webpack_public_path__ + "static/media/toggle_off_white_24dp.c9578e88.svg";